import { BaseAPI } from '../../BaseApi';
import { convertIOrderTagResponseToIOrderTagData, IOrderTagData } from '../../../types/order/tags/IOrderTagData';
import { UUID } from '../../../types/shared/UUID';
import { IOrderTagResponse } from '../../../types/order/tags/IOrderTagResponse';
import { eAPITags } from '../../eAPITags';
import {
  ICreateOrderTagRequest,
  IDeleteOrderTagRequest,
  IUpdateOrderTagRequest,
} from '../../../types/order/tags/ICreateOrderTagRequest';

export const OrderTagApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listOrderTags: build.query<IOrderTagData[], UUID>({
      query: (orderId) => `/timber/api/internal/orders/${orderId}/tags`,
      transformResponse: (responseList: IOrderTagResponse[]) =>
        responseList.map(convertIOrderTagResponseToIOrderTagData),
      providesTags: (result, error, orderId) => [{ id: orderId, type: eAPITags.OrderTagData }],
    }),
    createOrderTag: build.mutation<IOrderTagData, ICreateOrderTagRequest>({
      query: ({ orderId, tagId, value }) => ({
        url: `/timber/api/internal/orders/${orderId}/tags/${tagId}`,
        method: 'POST',
        body: { value },
      }),
      transformResponse: (response: IOrderTagResponse) => convertIOrderTagResponseToIOrderTagData(response),
      invalidatesTags: (result, error, { orderId }) => [{ id: orderId, type: eAPITags.OrderTagData }],
    }),
    updateOrderTag: build.mutation<IOrderTagData, IUpdateOrderTagRequest>({
      query: ({ orderId, tagId, value }) => ({
        url: `/timber/api/internal/orders/${orderId}/tags/${tagId}`,
        method: 'PATCH',
        body: { value },
      }),
      transformResponse: (response: IOrderTagResponse) => convertIOrderTagResponseToIOrderTagData(response),
      invalidatesTags: (result, error, { orderId }) => [{ id: orderId, type: eAPITags.OrderTagData }],
    }),
    deleteOrderTag: build.mutation<void, IDeleteOrderTagRequest>({
      query: ({ orderId, tagId }) => ({
        url: `/timber/api/internal/orders/${orderId}/tags/${tagId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { orderId }) => [{ id: orderId, type: eAPITags.OrderTagData }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListOrderTagsQuery,
  useCreateOrderTagMutation,
  useUpdateOrderTagMutation,
  useDeleteOrderTagMutation,
} = OrderTagApi;
